// Add flags you want to use on the project

export const flagsBuilder = [
  'flagBuilderLazyLoadSections',
  'flagBuilderPageGlobalStorage',
  'flagBuilderRemoveColumnBackground',
  'flagBuilderUploadDownloadZip',
  'flagBuilderUploadVideo',
  'flagBuilderWeightLimitation',
] as const;

export const flagsIM = [
  'flagImAddAttachment',
  'flagImCreateChannelApi',
  'flagImCreateConversation',
  'flagImEmojiPicker',
  'flagImCustomEmojiReactions',
] as const;

export default [
  ...flagsBuilder,
  ...flagsIM,
  'flagActivateFrontMonitoringDatadog',
  'flagAxpAdminNotifications',
  'flagAxpEngagementScoringImprovements',
  'flagAxpExportLimitations',
  'flagAxpNewUserIndex',
  'flagBraintree3DSecureSca',
  'flagCurrentSessionContext',
  'flagDsIsolationNewsDetailPage',
  'flagEvAblyInactivityTracker',
  'flagEvBlockContentUploadCkEditor',
  'flagEvBrandingWebsiteHeaderLogoToGlobalStorage',
  'flagEvCategoriesListV2',
  'flagEvDeployDsToCategoriesOnBo',
  'flagEvEventsBoRevamp',
  'flagEvEventsFoPerformance',
  'flagEvEventsValidations',
  'flagEvGsMembershipLogo',
  'flagEvImproveSoldOutEventsFo',
  'flagEvMembershipFoPagination',
  'flagEvMembershipValidations',
  'flagEvMentoringAdminMatch',
  'flagEvMentoringEmailsToggles',
  'flagEvMentoringMultipleMentorPrograms',
  'flagEvMessagingReactQuery',
  'flagEvOrderSummaryDsEvents',
  'flagEvOrderSummaryDsMemberships',
  'flagEvPaymentPageEvents',
  'flagEvPaymentPageMemberships',
  'flagEvPaymentsMovePromocode',
  'flagEvStripeCobrandedCards',
  'flagEvStripeDirectChargeForAllCC',
  'flagEvSuperAdminReadOnly',
  'flagEvTinyMce',
  'flagEvTinyMceOnlineAlerts',
  'flagEvTinyMceOrganizations',
  'flagEvUserPicturesToGlobalStorage',
  'flagEvVirusScanning',
  'flagFixedPeriodMvpForStanford',
  'flagGoogleMapsComponent',
  'flagHivehackNotifyPeople',
  'flagLiveFeedDesignImprovements2',
  'flagLogInRefactoring',
  'flagMobileAppsBoOptionalAndroidServiceAccountJson',
  'flagMobileNewDialog',
  'flagMutliSalesTax',
  'flagNewAnalyticsMvp',
  'flagProfileCustomHeader',
  'flagRefactoBottomLinks',
  'flagRequestUserAccountDeletion',
  'flagSuEmailSecurity',
  'flagTtPoRemoveUserSessionCookie',
  'flagUePerfMenuItem',
  'flagUeMobileCaretFooter',
  'flagUePerfMenuItem',
  'flagUeSearchDeactivateGlobal',
  'flagUjDynamicComponentsPerfUsersTopicsDiscussions',
  'flagUjAblyInternalNotifications',
  'flagUjbBiggerBadgeSize',
  'flagUjbDynamicComponentsPerf',
  'flagUjbGroupHeaderRedesign',
  'flagUjbLfPagination',
  'flagUjbTripGermanTransportation',
  'flagUseWhitelabelCustomCertificate',
  'flagUjSearchLocationAnonymous',
] as const;
